import { Box, CircularProgress, Typography } from "@mui/material";


const CircularProgressWithLabel = ({ value, color, valueColor,backgroundColor }) => (
<Box position="relative" display="inline-flex">
  {/* Background Track (The light orange circle) */}
  <CircularProgress
    variant="determinate"
    value={100}
    size={70}
    thickness={5}
    sx={{
      color: backgroundColor, // Very light orange/tan background
    }}
  />
  {/* Active Progress (The dark orange circle) */}
  <CircularProgress
    variant="determinate"
    value={value}
    size={70}
    thickness={5}
    sx={{
      color: color, // The darker orange color from your image
      position: "absolute",
      left: 0,
      [`& .MuiCircularProgress-circle`]: {
        strokeLinecap: "round", // Makes the ends of the bar rounded
      },
    }}
  />
  <Box
    top={0}
    left={0}
    bottom={0}
    right={0}
    position="absolute"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Typography
      variant="caption"
      component="div"
      sx={{ 
        fontWeight: 800, 
        fontSize: "15px", 
        fontFamily: "Inter",
        color:valueColor // Dark brown/orange text color
      }}
    >
      {`${Math.round(value)}%`}
    </Typography>
  </Box>
</Box>
);

export default CircularProgressWithLabel;